import { toast } from "sonner";
import { api } from "./api";

// Detect the 403 raised by backend utils/limits.py enforce_member_limit.
export const isLimitError = (e) =>
  e?.response?.status === 403 &&
  String(e?.response?.data?.detail || "").includes("Above your approval limit");

/* Show the limit error with a one-tap "Request owner approval" action.
 * `req` = { yacht_id, kind, ref_id, label, amount }. Returns true when the
 * error was a limit block (caller should skip its generic toast). */
export const limitToast = (e, req) => {
  if (!isLimitError(e) || !req?.yacht_id) return false;
  toast.error(String(e.response.data.detail), {
    duration: 12000,
    action: {
      label: "Request owner approval",
      onClick: async () => {
        try {
          await api.post("/approval-requests/escalate", req);
          toast.success("Approval request sent to the owner and managers");
        } catch (err) {
          toast.error("Could not send the request — please try again");
        }
      },
    },
  });
  return true;
};
